export interface TagRowMetrics {
  scrollWidth: number;
  clientWidth: number;
  scrollLeft: number;
}

export interface TagRowOverflowState {
  overflowing: boolean;
  atStart: boolean;
  atEnd: boolean;
}

export function tagRowOverflowState({
  scrollWidth,
  clientWidth,
  scrollLeft
}: TagRowMetrics): TagRowOverflowState {
  return {
    overflowing: scrollWidth - clientWidth > 1,
    atStart: scrollLeft <= 1,
    atEnd: scrollLeft + clientWidth >= scrollWidth - 1
  };
}

/** A row the overflow hook flags: its metrics and the attributes styles read. */
export interface TagRow extends TagRowMetrics {
  dataset: DOMStringMap;
}

/**
 * Flags a row as overflowing only if it still overflows once flagged. A
 * flagged row can lay out narrower than an unflagged one: the filter row's
 * Clear all gives up 4px of end padding to meet the column edge. A row whose
 * overflow that padding absorbed was flagged, lost the overflow and stayed
 * flagged, so its edge fade covered Clear all with nothing to scroll.
 * Nothing measured it again, because the padding resizes no content box the
 * observer watches and a row that cannot scroll fires no scroll event.
 */
export function settleTagRowOverflow(row: TagRow) {
  let { overflowing } = tagRowOverflowState(row);
  if (overflowing && row.dataset.overflowing !== "true") {
    row.dataset.overflowing = "true";
    ({ overflowing } = tagRowOverflowState(row));
  }
  row.dataset.overflowing = String(overflowing);
  updateTagRowEnds(row);
}

/** Records which ends of a row still hide a tag, for its edge fades. */
export function updateTagRowEnds(row: TagRow) {
  const { atStart, atEnd } = tagRowOverflowState(row);
  row.dataset.atStart = String(atStart);
  row.dataset.atEnd = String(atEnd);
}
